var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    attrs: {
      "className": "header--light"
    }
  }, [_c('sub-visual-office', {
    attrs: {
      "sh": "지점",
      "shRe": "본사",
      "bg": "/images/sub/visual/sv1-3-2.jpg",
      "link": "/introduction/office",
      "linkText": "본사가 궁금하다면?"
    }
  }, [_c('p', [_vm._v(" 고객사에 대한 깊은 이해를 바탕으로 효과적이고 전략적인 세일즈/캠페인을 기획 및 실행합니다. 또한 체계적인 교육을 통해 전문 브랜드 홍보대사 & 펀드레이저를 양성합니다. ")])]), _c('section', {
    staticClass: "section pt-0"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/about/branch/s1-img1.jpg",
      "bgOn": "/images/sub/about/branch/s1-img1-on.jpg",
      "tit": "지점장 & 부지점장"
    }
  }, [_c('div', {
    staticClass: "mb-8 mb-xl-16"
  }, [_c('num-content', {
    attrs: {
      "num": "01",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 지점 운영 및 관리 ")])])], 1), _c('div', {
    staticClass: "mb-8 mb-xl-16"
  }, [_c('num-content', {
    attrs: {
      "num": "02",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 캠페인 기획 및 컨설팅 ")])])], 1), _c('div', [_c('num-content', {
    attrs: {
      "num": "03",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 브랜드 홍보대사 & 펀드레이저 양성 ")])])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/about/branch/s1-img2.jpg",
      "bgOn": "/images/sub/about/branch/s1-img2-on.jpg",
      "tit": "브랜드 홍보대사 & 펀드레이저",
      "titWidth": "w-xl-50"
    }
  }, [_c('div', {
    staticClass: "mb-8 mb-xl-16"
  }, [_c('num-content', {
    attrs: {
      "num": "01",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 캠페인 활동 ")])])], 1), _c('div', {
    staticClass: "mb-8 mb-xl-16"
  }, [_c('num-content', {
    attrs: {
      "num": "02",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 고객사 브랜드의 가치 전달 ")])])], 1), _c('div', [_c('num-content', {
    attrs: {
      "num": "03",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 세일즈 및 홍보 대행 (제품 또는 서비스) ")])])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/about/branch/s1-img3.jpg",
      "bgOn": "/images/sub/about/branch/s1-img3-on.jpg",
      "tit": "어드민"
    }
  }, [_c('div', {
    staticClass: "mb-8 mb-xl-16"
  }, [_c('num-content', {
    attrs: {
      "num": "01",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 사무직 (지점 근무) ")])])], 1), _c('div', {
    staticClass: "mb-8 mb-xl-16"
  }, [_c('num-content', {
    attrs: {
      "num": "02",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 지점 채용 관리 ")])])], 1), _c('div', [_c('num-content', {
    attrs: {
      "num": "03",
      "space": "pl-8 pl-lg-12"
    }
  }, [_c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 사무 행정 및 총무 업무 ")])])], 1)])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section bg-grey"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 무한한 성장이 가능한 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 브랜드 홍보대사 & 펀드레이저 ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 세일즈웍스는 성과에 대한 인정 및 보상, 경력 개발을 위한 교육의 기회를 제공합니다. "), _c('br'), _vm._v(" 다양한 지원을 바탕으로 커리어를 확장하여 팀을 관리하고, 더 나아가 지점을 운영할 수 있습니다. ")])]), _c('v-divider'), _c('section', {
    staticClass: "section--sm"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-30 mb-lg-24"
  }, [_vm._v(" Stage 1"), _c('span', {
    staticClass: "txt-line mx-6 mx-lg-10"
  }), _c('span', {
    staticClass: "color-point"
  }, [_vm._v("첫 발을 내딛다")])]), _c('v-img', {
    staticClass: "w-100 mb-30 mb-lg-54",
    attrs: {
      "src": "/images/sub/about/branch/s2-img1.jpg"
    }
  }), _c('div', {
    staticClass: "px-md-30 px-lg-40"
  }, [_c('div', {
    staticClass: "mb-12 mb-lg-24"
  }, [_c('num-content', {
    attrs: {
      "num": "01",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 체계적인 교육 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 국내외 워크숍, 온라인 교육을 통해 고객사, 커뮤니케이션 스킬, 리더십 등 전문적인 교육을 받습니다. ")])])], 1), _c('div', {
    staticClass: "mb-12 mb-lg-24"
  }, [_c('num-content', {
    attrs: {
      "num": "02",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 세일즈/캠페인 활동 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 고객사의 얼굴이 되어 브랜드의 가치를 전달합니다. ")])])], 1), _c('div', [_c('num-content', {
    attrs: {
      "num": "03",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 역량 강화 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 전문가의 피드백을 통해 나에게 맞는 목표를 설정하고 계획을 수립합니다. ")])])], 1)])], 1), _c('v-divider'), _c('section', {
    staticClass: "section--sm"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-30 mb-lg-24"
  }, [_vm._v(" Stage 2"), _c('span', {
    staticClass: "txt-line mx-6 mx-lg-10"
  }), _c('span', {
    staticClass: "color-point"
  }, [_vm._v("팀을 이끌다")])]), _c('v-img', {
    staticClass: "w-100 mb-30 mb-lg-54",
    attrs: {
      "src": "/images/sub/about/branch/s2-img2.jpg"
    }
  }), _c('div', {
    staticClass: "px-md-30 px-lg-40"
  }, [_c('div', {
    staticClass: "mb-12 mb-lg-24"
  }, [_c('num-content', {
    attrs: {
      "num": "01",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 팀 운영 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 팀원들과 소통을 통해 목표를 설정하고, 팀원들이 성장할 수 있도록 전략을 수립하여 팀을 성장시킵니다. ")])])], 1), _c('div', {
    staticClass: "mb-12 mb-lg-24"
  }, [_c('num-content', {
    attrs: {
      "num": "02",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 세일즈/캠페인 활동 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 멘토가 되어 캠페인 활동을 교육하고 지원합니다. ")])])], 1), _c('div', [_c('num-content', {
    attrs: {
      "num": "03",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 역량 강화 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 지점장과 소통하며 팀의 발전방향을 논의하며 리더십을 강화합니다. ")])])], 1)])], 1), _c('v-divider'), _c('section', {
    staticClass: "section--sm pb-0"
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-30 mb-lg-24"
  }, [_vm._v(" Stage 3"), _c('span', {
    staticClass: "txt-line mx-6 mx-lg-10"
  }), _c('span', {
    staticClass: "color-point"
  }, [_vm._v("지점을 운영하다")])]), _c('v-img', {
    staticClass: "w-100 mb-30 mb-lg-54",
    attrs: {
      "src": "/images/sub/about/branch/s2-img3.jpg"
    }
  }), _c('div', {
    staticClass: "px-md-30 px-lg-40"
  }, [_c('div', {
    staticClass: "mb-12 mb-lg-24"
  }, [_c('num-content', {
    attrs: {
      "num": "01",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 지점 운영 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 세일즈웍스의 비즈니스 운영 방식을 배우고 지점을 효율적으로 관리합니다. ")])])], 1), _c('div', {
    staticClass: "mb-12 mb-lg-24"
  }, [_c('num-content', {
    attrs: {
      "num": "02",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 인재 양성 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 인재를 발굴하고 전문적인 교육 과정을 개발 및 수행하여 전문가를 양성합니다. ")])])], 1), _c('div', [_c('num-content', {
    attrs: {
      "num": "03",
      "space": "pl-8 pl-lg-16"
    }
  }, [_c('h5', {
    staticClass: "tit-txt font-weight-bold mb-2"
  }, [_vm._v(" 역량 강화 ")]), _c('p', {
    staticClass: "page-text--sm color-grey-7"
  }, [_vm._v(" 해외 지사와 소통하며 글로벌 네트워크를 구축하고, 전문 경영인으로 성장하기 위한 교육을 받습니다. ")])])], 1)])], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 전국 지점 위치 ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 전국 주요 도시에 위치한 지점을 바탕으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" 전국적인 캠페인 활동을 진행하고 있습니다. ")])]), _c('div', {
    attrs: {
      "data-aos": "zoom-in-up"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mb-30 mb-lg-70",
    attrs: {
      "src": "/images/sub/about/branch/s3-img.jpg",
      "max-width": "1000",
      "contain": ""
    }
  }), _c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('arrow-btn', {
    attrs: {
      "tit": "지점 상세 정보",
      "color": "primary",
      "link": "/location",
      "type": "to"
    }
  })], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }